module.exports = __webpack_public_path__ + "img/logo-los-cocos.136af1eb.png";